"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var constants = _interopRequireWildcard(require("./constants"));

var _remove = _interopRequireDefault(require("lodash/remove"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  modals: [],
  hasWizard: false,
  hasDialog: false
};
exports.initialState = initialState;

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case constants.SHOW_MODAL:
      {
        var maxId = state.modals.length ? Math.max.apply(null, state.modals.map(function (modal) {
          return modal.modalKey;
        })) : 0;
        var modals = state.modals.slice(0);
        modals.push({
          type: action.payload.type,
          props: action.payload.props,
          modalKey: maxId + 1
        });
        return _objectSpread({}, state, {
          modals: modals
        });
      }

    case constants.HIDE_MODAL:
      {
        var _modals = state.modals.slice(0); // remove from array
        // modals.splice(modals.indexOf(modals.filter(i => i.modalKey === action.modalKey)[0]), 1)
        // _.remove(modals, i => i.modalKey === action.modalKey)


        (0, _remove["default"])(_modals, {
          modalKey: action.modalKey
        });
        return _objectSpread({}, state, {
          modals: _modals
        });
      }

    case constants.SHOW_WIZARD:
      return _objectSpread({}, state, {
        hasWizard: true
      });

    case constants.HIDE_WIZARD:
      return _objectSpread({}, state, {
        hasWizard: false
      });

    case constants.SHOW_DIALOG:
      return _objectSpread({}, state, {
        hasDialog: true
      });

    case constants.HIDE_DIALOG:
      return _objectSpread({}, state, {
        hasDialog: false
      });

    case constants.RESET_MODALS:
      return _objectSpread({}, state, {
        modals: []
      });
  }

  return state;
};

var _default = reducer;
exports["default"] = _default;